<script setup lang="ts">
import Logo from "@/components/identity/Logo.vue";
import Triangle from "@/components/identity/Triangle.vue";
</script>

<template>
    <div class="flex">
        <div class="flex bg-black gap-3 pr-3">
            <Triangle />
            <Logo :size="40" />
        </div>
        <Triangle color="black" />
    </div>
</template>
